<div class="home-filter-shell">
  <HomeNavBar @active-profile-loaded="set_active_profile" />
  <InactivityModal />

  <div class="container-fluid bg-white pb-extra">
    <div class="row p-2 g-3">
      <div class="col-12">
        <header class="d-flex gap-2 align-items-start mb-3">
          <button
            @click="$router.push({ name: 'organisation' })"
            class="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center back-btn"
            type="button"
          >
            <i class="bi bi-chevron-left fs-5"></i>
          </button>

          <div>
            <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
              <h4 class="fw-bold mb-0">Section 18A Configuration</h4>
              <span class="task-chip task-chip-status text-capitalize">{{ has_section_18a_config ? 'Configured' : 'Not Configured' }}</span>
            </div>
            <p class="mb-0">Configure the Section 18A details and upload the approved letter used for donation compliance.</p>
          </div>
        </header>

        <div class="home-filter-panel">
          <div class="row justify-content-center g-3 align-items-start">
            <div class="col-12 col-lg-10 col-xl-8">
              <div v-if="section_18a_loading" class="text-muted text-xxs mb-3">Loading Section 18A details...</div>
              <div class="alert alert-warning text-xxs py-1 px-3 mb-2">
                Please confirm the registration details, tax references, and approval letter before saving these Section 18A details.
              </div>

              <div class="row g-3">
                <div class="col-12 col-md-6">
                  <label class="form-label text-xxs fw-500">
                    Registration Number <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="section_18a_form.registration_number"
                    type="text"
                    class="form-control rounded text-xxs"
                    :class="{ 'is-invalid': section_18a_form_errors.registration_number }"
                    placeholder="e.g. 2024/123456/08" maxlength="14" @input="format_registration_number_input"
                  />
                  <div v-if="section_18a_form_errors.registration_number" class="invalid-feedback d-block text-xxs">{{ section_18a_form_errors.registration_number }}</div>
                </div>

                <div class="col-12 col-md-6">
                  <label class="form-label text-xxs fw-500">
                    Income Tax Reference Number <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="section_18a_form.income_tax_reference_number"
                    type="text"
                    class="form-control rounded text-xxs"
                    :class="{ 'is-invalid': section_18a_form_errors.income_tax_reference_number }"
                    placeholder="e.g. 0123456789" maxlength="10"
                  />
                  <div v-if="section_18a_form_errors.income_tax_reference_number" class="invalid-feedback d-block text-xxs">{{ section_18a_form_errors.income_tax_reference_number }}</div>
                </div>

                <div class="col-12 col-md-6">
                  <label class="form-label text-xxs fw-500">
                    PBO Number <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="section_18a_form.pbo_number"
                    type="text"
                    class="form-control rounded text-xxs"
                    :class="{ 'is-invalid': section_18a_form_errors.pbo_number }"
                    placeholder="e.g. 930012345" maxlength="9"
                  />
                  <div v-if="section_18a_form_errors.pbo_number" class="invalid-feedback d-block text-xxs">{{ section_18a_form_errors.pbo_number }}</div>
                </div>

                <div class="col-12 col-md-6">
                  <label class="form-label text-xxs fw-500">
                    Effective Date <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="section_18a_form.effective_date"
                    type="date" max="2026-08-04"
                    class="form-control rounded text-xxs"
                    :class="{ 'is-invalid': section_18a_form_errors.effective_date }"
                  />
                  <div v-if="section_18a_form_errors.effective_date" class="invalid-feedback d-block text-xxs">{{ section_18a_form_errors.effective_date }}</div>
                </div>

                <div class="col-12 pt-2">
                  <div class="border-top pt-3">
                    <label class="form-label text-xxs fw-500 mb-1">Approved Letter</label>
                    <div class="text-muted text-xxs mb-2">Upload your SARS approval letter and keep it attached to this Section 18A setup.</div>

                    <div v-if="selected_approval_letter_name" class="border rounded bg-white px-3 py-2 d-flex align-items-center justify-content-between gap-2 flex-wrap text-xxs mb-2">
                      <div class="d-flex align-items-center gap-2 min-w-0">
                        <i class="bi bi-file-earmark text-primary"></i>
                        <span class="text-truncate">{{ selected_approval_letter_name }}</span>
                      </div>
                      <button type="button" class="btn btn-link text-danger text-xxs p-0" @click="clear_section_18a_approval_letter">
                        Clear
                      </button>
                    </div>

                    <div v-else-if="current_approval_letter_url" class="border rounded bg-white px-3 py-2 d-flex align-items-center justify-content-between gap-2 flex-wrap text-xxs mb-2">
                      <div class="d-flex align-items-center gap-2 min-w-0">
                        <div class="bg-primary-subtle text-primary rounded d-flex align-items-center justify-content-center flex-shrink-0" >
                          <i class="bi bi-file-earmark"></i>
                        </div>
                        <div class="min-w-0">
                          <div class="fw-500 text-truncate">{{ current_approval_letter_name }}</div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          class="btn btn-light border btn-sm text-xxs"
                          @click="show_section_18a_preview = true"
                        >
                          <i class="bi bi-eye"></i>
                        </button>
                      </div>
                    </div>

                    <label
                      for="section18aApprovalLetterInput"
                      class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded p-3 mb-2 text-center transition-all position-relative"
                      :class="section_18a_is_dragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
                      @dragover.prevent="section_18a_is_dragging = true"
                      @dragenter.prevent="section_18a_is_dragging = true"
                      @dragleave.prevent="section_18a_is_dragging = false"
                      @drop.prevent="handle_section_18a_file_drop"
                    >
                      <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                        <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                        <span class="fw-bold text-black text-sm">Drag & Drop media here or click</span>
                      </div>

                      <input
                        id="section18aApprovalLetterInput"
                        type="file"
                        class="webview-file-input"
                        accept=".pdf"
                        @change="handle_section_18a_approval_letter_change"
                      >
                    </label>
                    <div v-if="section_18a_form_errors.approval_letter" class="invalid-feedback d-block text-xxs">{{ section_18a_form_errors.approval_letter }}</div>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-wrap justify-content-end gap-2 mt-4">
                <button
                  v-if="has_section_18a_config"
                  type="button"
                  class="btn btn-danger text-xxs rounded px-3"
                  :disabled="section_18a_saving"
                  @click="delete_section_18a_config"
                >
                  {{ section_18a_saving ? 'Removing...' : 'Delete Section 18A' }}
                </button>

                <button
                  v-if="!has_section_18a_config || is_section_18a_dirty"
                  type="button"
                  class="btn btn-primary text-xxs rounded px-3"
                  :disabled="section_18a_saving || section_18a_loading"
                  @click="save_section_18a_config"
                >
                  {{ section_18a_saving ? 'Saving...' : (has_section_18a_config ? 'Update Section 18A' : 'Save Section 18A') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <teleport to="body">
          <div v-if="show_section_18a_preview">
            <div class="modal fade show d-block" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content border-0 rounded-4 shadow-sm overflow-hidden">
                  <div class="modal-header border-0 shadow-sm">
                    <div>
                      <h5 class="modal-title text-xs mb-0 text-truncate">{{ current_approval_letter_name || 'Approval letter preview' }}</h5>
                    </div>
                    <button
                      type="button"
                      class="btn-close btn-close-black"
                      aria-label="Close"
                      @click="show_section_18a_preview = false"
                    ></button>
                  </div>

                  <div class="modal-body p-3 p-lg-4">
                    <div class="border rounded-3 bg-white p-2">
                      <iframe
                        v-if="current_approval_letter_is_pdf"
                        :src="current_approval_letter_url"
                        class="w-100 rounded border-0 bg-white"
                      ></iframe>

                      <img
                        v-else-if="current_approval_letter_is_image"
                        :src="current_approval_letter_url"
                        :alt="current_approval_letter_name"
                        class="img-fluid rounded d-block mx-auto"
                      />

                      <div v-else class="text-center text-muted text-xxs py-5">
                        Preview is not available for this file type.
                        <div class="mt-2">
                          <a :href="current_approval_letter_url" target="_blank" rel="noopener noreferrer" class="text-decoration-none">
                            Open file in new tab
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-backdrop fade show" @click="show_section_18a_preview = false"></div>
          </div>
        </teleport>
      </div>
    </div>
  </div>

  <StickyNav activeTab="normal_loans_info" />
</div>
